module.exports = __webpack_public_path__ + "img/tool2.51489130.png";